import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import { lcarsBlockSx } from '../theme/tokens';

/** The one solid-fill mark in the app: dark text on an accent-filled
 * rectangle (not a pill — pills are reserved for real buttons) — the exact
 * inverse of `StatusBadge`'s hairline outline, for the exact opposite job.
 *
 * `StatusBadge` is for the many: 40 site names, a row of active corps.
 * Outlined so density survives and the danger-scale colors stay readable.
 *
 * `LcarsBlock` is for the one: the thing a surface IS — a system's class, a
 * site's category. Budget is one or two per viewport; a page of solid
 * blocks reads as a toy and the danger scale stops meaning danger. */
const LcarsBlock: React.FC<{
  label: string;
  accent: string;
  size?: 'sm' | 'md';
  sx?: SxProps<Theme>;
}> = ({ label, accent, size = 'md', sx }) => (
  <Box
    component="span"
    sx={{
      ...lcarsBlockSx(accent),
      fontSize: size === 'sm' ? '0.72rem' : '0.86rem',
      px: size === 'sm' ? 1.15 : 1.5,
      py: size === 'sm' ? 0.5 : 0.75,
      ...sx,
    }}
  >
    {label}
  </Box>
);

export default LcarsBlock;
